import { MessageRequestTypes, postMessageToParentExtension } from 'extension-communication';

export default function sendRenderCompleteMessageToExtension() {
    postMessageToParentExtension({ type: MessageRequestTypes.MiniContentRendered });
}
